// Same endpoints the mobile Team screens use (ahd-mobile/src/screens/partner/team)
export const TEAM_ENDPOINTS = {
  list: "/api/partner/team/partnerTeams",
  save: "/api/partner/team", // POST creates, PUT updates
  remove: (id) => `/api/partner/team/deletePartnerTeam/${id}`,
  // "mmeber" is how the backend spells this route (mobile calls it the same way), so it must not be "fixed" here
  members: (teamId) => `/api/partner/team/mmeber/team/${teamId}`,
  addMember: "/api/partner/team/member/add",
  removeMember: (id) => `/api/partner/team/member/${id}`,
  // Mobile only lets a partner add members while the plan has seats
  subscription: "/api/v1/subscriptions/my-subscription",
};

export const TEAMS_HOME = "/partner/team";
export const SUBSCRIPTION_PATH = "/partner/subscription";

export const TEAM_PAGE_SIZE = 12;
export const TEAM_FETCH_PAGE_SIZE = 100;
export const TEAM_MAX_PAGES = 50;

export const MEMBER_ROLES = ["OWNER", "ADMIN", "MANAGER", "AGENT", "ASSOCIATE", "VIEWER"];
export const DEFAULT_MEMBER_ROLE = "ADMIN";
